<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Roles Partidos
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Lista
        </small>
      </h1>
    </div>



    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="bgc-primary-d1 text-white px-3 py-25">
            <div class="row">
            <div class="col-md-6 col-12">
                <span class="text-90">Lista de</span>
                Rol de Partidos
            </div>
            <div class="col-md-6 col-12">
                <div class="columns columns-right btn-group float-right">
                <button *ngIf="aplicacion.puede_crear" title="Nuevo" (click)="crearNuevoRolPartido()" class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1 bs-print" type="button">
                    <i class="fa fa-plus text-purple-d1"></i>
                </button>
                </div>
            </div>
            </div>
        </div>
        <div class="bootstrap-table bootstrap4">
            <div class="fixed-table-toolbar">
            <div class="row">
                <div class="col-12 col-md-7">
                <div class="row">
                    <div class="col-12 col-md-12">
                    <app-paginator-header [paginator]="this"></app-paginator-header>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-12">
                    <div class="row">
                        <div class="col-md-2 col-sm-12" ><label>Usuarios </label></div>
                        <div class="col-md-3 col-sm-12">
                        <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="filter.usuario">
                            <option [ngValue]="usuario" *ngFor="let usuario of filter.usuarios">{{usuario.nombre_usuario}}</option>
                        </select>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-12 col-md-5 p-0">
                <div class="row">
                    <div class="col-12">
                    <button (click)="getSearch(text_search,null)" class="btn btn-xs btn-app btn-primary my-1" type="button" name="fullscreen" aria-label="Fullscreen" title="Buscar">
                        <i class="d-block h-4 fa fa fa-search text-150"></i>
                    </button>&nbsp;
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="clearfix"></div>
            <div class="fixed-table-container" style="padding-bottom: 0px;">
            <div class="fixed-table-header" style="display: none;">
                <table></table>
            </div>
            <div id="gallery" class="fixed-table-body">
                <div class="fixed-table-loading table table-bordered table-hover" style="top: 46.6167px;">
                <span class="loading-wrap">
                    <span class="animation-wrap">
                    <span class="animation-dot"></span>
                    </span>
                </span>
                </div>
                <table *ngIf="roles_partidos.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive" id="table">
                <thead class="bgc-white text-grey text-uppercase text-80">
                    <tr>
                    <th>N°</th>
                    <th class="center"><a href="javascript:void(0)">Código <span id="codigo" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Logo <span id="logo" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Campeonato <span id="campeonato" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Rol <span id="rol" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center">Fechas Asignadas</th>
                    <th class="center"><a href="javascript:void(0)">Actualizado <span id="actualizado" class="sort fa fa-sort icon-only"></span></a></th>
                    <th class="center"><a href="javascript:void(0)">Validez <span id="validez" class="sort fa fa-sort icon-only"></span></a></th>
                    <th style="text-align: center; width: 140px; " data-field="tools">
                        
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rol_partido of roles_partidos; let i=index;">
                    <td>
                        {{(i+1)+(this.itemsPerPage*(this.currentPage-1))}}
                    </td>
                    <td>
                        {{rol_partido.codigo}}
                    </td>
                    <td>
                        <div class="imagen-campeonato-vista clearfix">
                        <a href="{{rest_server+rol_partido.campeonato.logo}}" title="{{rol_partido.campeonato.nombre}}" data-rel="colorbox">
                            <img width="50" height="50" alt="sin imagen" src="{{rest_server+rol_partido.campeonato.logo}}" />
                        </a>
                    </div>
                    </td>
                    <td>
                        {{rol_partido.campeonato.nombre}}
                    </td>
                    <td>
                        {{rol_partido.rol.nombre}}
                    </td>
                    <td>
                        <span class="badge badge-sm badge-info mr-1" *ngFor="let fecha_partido of rol_partido.fechas_partidos">
                            {{fecha_partido.fecha_texto}} ({{fecha_partido.cantidad_partidos}})
                        </span>
                    </td>
                    <td>
                        {{rol_partido.updatedAt | date:'dd/MM/yyyy - HH:mm'}}
                    </td>
                    <td *ngIf="rol_partido.activo"><span class="badge badge-sm badge-success">ACTIVO</span></td>
                    <td *ngIf="!rol_partido.activo"><span class="badge badge-sm badge-danger">ANULADO</span></td>
                    <td style="text-align: center; width: 140px; ">
                        <div class="action-buttons">
                            <a *ngIf="rol_partido.activo" class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="abrirCierreCaja(rol_partido)">
                                <i class="fa fa-lock text-105"></i>
                            </a>                        
                        </div>
                    </td>
                    </tr>
                </tbody>
                </table>
            </div>
            <div class="fixed-table-footer">
                <table><thead><tr></tr></thead></table>
            </div>
            </div>
            <div class="fixed-table-pagination">
            <app-paginator-footer *ngIf="roles_partidos.length>0" class="pagination-detail" [paginator]="this"></app-paginator-footer>
            </div>
        </div>
      </div>
    </div>
</div>

<ng-template #modal_seleccion_fecha_cierre let-modal>
    <div class="modal-header card-header">
        <div class="col-8">
            <span class="text-blue text-125">Cierre de Caja Mesa</span>
        </div>
        <div class="col-4">
            <button type="button" class="btn btn-primary btn-danger float-right" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 align-top bigger-125"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <p class="text-dark-m2">
            El oficial de mesa <b>{{filter.usuario.persona.nombre_completo}}</b> tiene partidos asignados en
            <b>{{fechas_cierre.length}}</b> fechas de este rol. Seleccione la fecha del cierre.
        </p>
        <table class="table text-dark-m2 text-95 table-bordered table-hover table-striped">
            <thead class="bgc-white text-grey text-uppercase text-80">
                <tr>
                    <th class="center">Fecha</th>
                    <th class="center">Partidos</th>
                    <th class="center">Estado</th>
                    <th style="text-align: center; width: 80px;" data-field="tools"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let fecha_cierre_item of fechas_cierre">
                    <td>{{fecha_cierre_item.fecha_texto}}</td>
                    <td>{{fecha_cierre_item.cantidad_partidos}}</td>
                    <td>
                        <span class="badge badge-sm" [ngClass]="{'badge-warning':fecha_cierre_item.estado=='PENDIENTE','badge-primary':fecha_cierre_item.estado=='GUARDADO','badge-success':fecha_cierre_item.estado=='PROCESADO'}">
                            {{fecha_cierre_item.estado}}
                        </span>
                    </td>
                    <td style="text-align: center;">
                        <div class="action-buttons">
                            <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="seleccionarFechaCierre(fecha_cierre_item)">
                                <i class="fa fa-lock text-105"></i>
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #modal_registro_caja_mesa let-modal>
    <div class="modal-header card-header">
        <div class="col-4">
            <span class="text-blue text-125">Cierre de Caja</span>
            <span class="badge badge-info ml-1">{{fecha_cierre_texto}}</span>
            <span *ngIf="cierre_multiples_fechas" class="badge badge-warning ml-1" title="Cierre registrado antes de la separacion por fecha, agrupa los partidos de varios dias">VARIAS FECHAS</span>
        </div>
        <div class="col-8">
            <button type="button" class="btn btn-primary btn-primary" (click)="guardarRolPartidoCierre()">
                <i class="fa fa-save red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button *ngIf="cierre_caja._id" type="button" class="btn btn-success btn-success" (click)="generarmensajeWhatsapp()">
                <i class="fab fa-whatsapp red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button type="button" class="btn btn-warning" (click)="tomarFotoPlanilla()" title="Sacar foto a la planilla y llenar el formulario">
                <i class="fa fa-camera red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button type="button" class="btn btn-warning" (click)="subirFotoPlanilla()" title="Subir la foto de la planilla desde el dispositivo">
                <i class="fa fa-upload red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button type="button" class="btn btn-primary btn-danger" (click)="modal.dismiss('Cross click')" >
              <i class="fa fa-times red2 align-top bigger-125"></i>
          </button>
        </div>
    </div>
    <div class="modal-body card-body">
        <!--capture abre directamente la camara del celular, en escritorio el navegador lo ignora y muestra el selector de archivos-->
        <input id="foto-planilla-camara" style="display:none" type="file" accept="image/*" capture="environment" (change)="subirArchivoFotoPlanilla($event)">
        <input id="foto-planilla-archivo" style="display:none" type="file" accept=".png,.jpg,.jpeg" (change)="subirArchivoFotoPlanilla($event)">

        <ng-container *ngFor="let partido of cierre_caja.partidos; let i=index;">
            <div class="accordion" id="a{{i}}-{{partido.id}}">
                <div class="card border-0 bgc-green-l5 overflow-visible">
                    <div class="card-header border-0 bgc-transparent mb-0 input-score" id="h-{{partido.equipo_1.id}}">
                        <h2 class="card-title bgc-transparent text-green-d2 brc-green">
                        <a class="d-style btn btn-white bgc-white btn-brc-tp btn-h-outline-green btn-a-outline-green accordion-toggle border-l-3 radius-0 collapsed" href="#c-{{partido.equipo_1.id}}" data-toggle="collapse" aria-expanded="false" aria-controls="c-{{partido.equipo_1.id}}">
                            {{partido.equipo_1.nombre}} 
                            <span class="v-collapsed px-3px radius-round d-inline-block brc-grey-l1 border-1 mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-90"></i>
                        </span>
                            <span class="v-n-collapsed px-3px radius-round d-inline-block bgc-green mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-white text-90 pt-1px"></i>
                        </span>
                        </a>
                        </h2>
                        <input only-num [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_1" [(ngModel)]="partido.marcador_equipo_1" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_1===null || partido.marcador_equipo_1 < 0)}">
                        <div class="dropdown">
                            <button id="m{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <span class="position-absolute badge radius-round text-80">{{sumarMarcadorEquipo(partido.equipo_1)}}</span>
                                <i class="fa fa-caret-down"></i>
                            </button>
                            <div class="dropdown-menu bgc-primary" aria-labelledby="m{{partido.equipo_1.id}}">
                                <ng-container *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'">
                                    <span class="dropdown-item p-0 d-inline-block">{{jugador.jugador.persona.nombre_completo}} <input type="number" min="0" step="1" class="form-control float-right" name="marcador_jugador" [(ngModel)]="jugador.jugador.marcador" ></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div id="c-{{partido.equipo_1.id}}" class="collapse" aria-labelledby="h-{{partido.equipo_1.id}}" data-parent="a{{i}}-{{partido.equipo_1.id}}">
                        <div class="card-body pt-1 border-l-3 brc-green bgc-green-l5 p-0">
                        <div class="card border-0 shadow-sm radius-0">
                            <div class="card-header bgc-primary-d1">
                                <label class="text-white">¿Dio W.O.? <input (change)="establecerWOEquipo1(partido)" name="switch-field-eq1" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_1.es_wo"/></label>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'ponchillos')">
                                    <i class="fas fa-tshirt text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'sin balon')">
                                    <i class="fas fa-futbol text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_1,'sin cintillo')">
                                    <i class="fas fa-tape text-105"></i>
                                </a>
                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="crearNuevoJugador(partido.equipo_1)">
                                    <i class="fas fa-plus text-105"></i>
                                </a>
                                <div class="dropdown">
                                    <button id="a{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span class="sr-only">Toggle Dropdown</span>
                                        <span class="position-absolute badge radius-round text-80">{{partido.lista_amarillas_equipo_1?partido.lista_amarillas_equipo_1.length:0}}</span>
                                        <i class="fa fa-caret-down"></i>
                                    </button>
                                    <div class="dropdown-menu bgc-warning" aria-labelledby="a{{partido.equipo_1.id}}">
                                        <a class="dropdown-item p-0" href="#" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_1,jugador.jugador,'AMARILLA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                    </div>
                                </div>
                                <div class="dropdown">
                                    <button id="r{{partido.equipo_1.id}}" type="button" class="px-2 btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span class="sr-only">Toggle Dropdown</span>
                                        <span class="position-absolute badge radius-round text-80">{{partido.lista_rojas_equipo_1?partido.lista_rojas_equipo_1.length:0}}</span>
                                        <i class="fa fa-caret-down"></i>
                                    </button>
                                    <div class="dropdown-menu bgc-danger" aria-labelledby="r{{partido.equipo_1.id}}">
                                        <a class="dropdown-item p-0 text-white" href="#" *ngFor="let jugador of partido.equipo_1.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_1,jugador.jugador,'ROJA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-header bgc-primary-d1" *ngIf="partido.equipo_1.detalles_ventas_pendientes.length>0">
                                <p class="card-title text-white">Pendientes:</p>
                                <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="partido.equipo_1.pendiente_seleccionado">
                                    <option class="text-white" [ngClass]="{'bgc-danger':detalle_venta.producto.nombre.includes('ROJA'),'bgc-warning':detalle_venta.producto.nombre.includes('AMARILLA')}" [ngValue]="detalle_venta" *ngFor="let detalle_venta of partido.equipo_1.detalles_ventas_pendientes">{{detalle_venta.venta.fecha | date:'dd/MM/yyyy'}} {{detalle_venta.venta.saldo.toFixed(2)}} {{detalle_venta.producto.nombre}} {{detalle_venta.descripcion}}</option>
                                </select>
                                <button type="button" class="btn btn-success btn-sm" (click)="agregarPendiente(partido.equipo_1,partido.equipo_1.pendiente_seleccionado)">
                                    <i class="ace-icon fa fa-arrow-down bigger-110"></i>
                                </button>
                            </div>
                            <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                            <table class="table table-striped table-hover mb-0 text-danger">
                                <thead class="text-dark-l2 text-95">
                                <tr>
                                    <th>
                                    <i class="far fa-user text-blue mr-1px"></i>
                                    Pago
                                    </th>
                                    <th>
                                    <i class="fa fa-money-bill-alt text-success-d1 mr-1px"></i>
                                    Efectivo
                                    </th>
                                    <th>
                                    <i class="fa fa-qrcode text-black-d1 mr-1px"></i>
                                    QR
                                    </th>
                                    <th style="text-align: center;" data-field="tools">
                                    
                                    </th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr *ngFor="let detalle_pago of partido.equipo_1.detalle_pago; let i=index;">
                                    <td class="text-dark-m2">{{detalle_pago.producto.nombre}} {{detalle_pago.descripcion}} {{detalle_pago.fecha}} </td>
                                    <td class="input-score">
                                        <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_1.id}}" [(ngModel)]="detalle_pago.importe">
                                    </td>
                                    <td class="input-score">
                                        <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_1.id}}" [(ngModel)]="detalle_pago.qr">
                                    </td>
                                    <td class="p-0" style="text-align: center;">
                                    <div class="action-buttons">
                                        <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="eliminarServicio(partido,partido.equipo_1,detalle_pago)">
                                        <i class="fa fa-trash-alt text-105"></i>
                                        </a>
                                    </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div><!-- /.card-body -->
                        </div><!-- /.card -->
                        </div>
                    </div>
                </div>

                <div class="card border-0 bgc-green-l5 overflow-visible">
                    <div class="card-header border-0 bgc-transparent mb-0 input-score" id="h-{{partido.equipo_2.id}}">
                        <h2 class="card-title bgc-transparent text-green-d2 brc-green">
                        <a class="d-style btn btn-white bgc-white btn-brc-tp btn-h-outline-green btn-a-outline-green accordion-toggle border-l-3 radius-0 collapsed" href="#c-{{partido.equipo_2.id}}" data-toggle="collapse" aria-expanded="false" aria-controls="c-{{partido.equipo_2.id}}">
                            {{partido.equipo_2.nombre}}
                            <span class="v-collapsed px-3px radius-round d-inline-block brc-grey-l1 border-1 mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-90"></i>
                        </span>
                            <span class="v-n-collapsed px-3px radius-round d-inline-block bgc-green mr-3 text-center position-rc">
                            <i class="fa fa-angle-down toggle-icon w-2 mx-1px text-white text-90 pt-1px"></i>
                        </span>
                        </a>
                        </h2>
                        <input only-num [disabled]="partido.w_o_equipo_1.es_wo || partido.w_o_equipo_2.es_wo" type="number" min="0" step="0" class="form-control" name="marcador_2" [(ngModel)]="partido.marcador_equipo_2" [ngClass]="{'brc-danger-m1 border-3':(partido.marcador_equipo_2===null || partido.marcador_equipo_2 < 0)}">
                        <div class="dropdown">
                            <button id="m{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                                <span class="position-absolute badge radius-round text-80">{{sumarMarcadorEquipo(partido.equipo_2)}}</span>
                                <i class="fa fa-caret-down"></i>
                            </button>
                            <div class="dropdown-menu bgc-primary" aria-labelledby="m{{partido.equipo_2.id}}">
                                <ng-container *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'">
                                    <span class="dropdown-item p-0 d-inline-block">{{jugador.jugador.persona.nombre_completo}} <input type="number" min="0" step="1" class="form-control float-right" name="marcador_jugador" [(ngModel)]="jugador.jugador.marcador" ></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div id="c-{{partido.equipo_2.id}}" class="collapse" aria-labelledby="h-{{partido.equipo_2.id}}" data-parent="a{{i}}-{{partido.equipo_2.id}}">
                        <div class="card-body pt-1 border-l-3 brc-green bgc-green-l5 p-0">
                            <div class="card border-0 shadow-sm radius-0">
                                <div class="card-header bgc-primary-d1">
                                    <label class="text-white">¿Dio W.O.? <input (change)="establecerWOEquipo2(partido)" name="switch-field-eq1" class="ace-switch input-lg ace-switch-sino bgc-green-d1" type="checkbox" [(ngModel)]="partido.w_o_equipo_2.es_wo"/></label>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'ponchillos')">
                                        <i class="fas fa-tshirt text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'sin balon')">
                                        <i class="fas fa-futbol text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="agregarProductoAdicional(partido.equipo_2,'sin cintillo')">
                                        <i class="fas fa-tape text-105"></i>
                                    </a>
                                    <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-white btn-a-outline-white btn-text-white" href="javascript:void(0)" (click)="crearNuevoJugador(partido.equipo_2)">
                                        <i class="fas fa-plus text-105"></i>
                                    </a>
                                    <div class="dropdown">
                                        <button id="a{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="sr-only">Toggle Dropdown</span>
                                            <span class="position-absolute badge radius-round text-80">{{partido.lista_amarillas_equipo_2?partido.lista_amarillas_equipo_2.length:0}}</span>
                                            <i class="fa fa-caret-down"></i>
                                        </button>
                                        <div class="dropdown-menu bgc-warning" aria-labelledby="a{{partido.equipo_2.id}}">
                                            <a class="dropdown-item p-0" href="#" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_2,jugador.jugador,'AMARILLA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                        </div>
                                    </div>
                                    <div class="dropdown">
                                        <button id="r{{partido.equipo_2.id}}" type="button" class="px-2 btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="sr-only">Toggle Dropdown</span>
                                            <span class="position-absolute badge radius-round text-80">{{partido.lista_rojas_equipo_2?partido.lista_rojas_equipo_2.length:0}}</span>
                                            <i class="fa fa-caret-down"></i>
                                        </button>
                                        <div class="dropdown-menu bgc-danger" aria-labelledby="r{{partido.equipo_2.id}}">
                                            <a class="dropdown-item p-0 text-white" href="#" *ngFor="let jugador of partido.equipo_2.jugadores | orderBy:'jugador.persona.nombre_completo'" (click)="agregarTarjetaPago(partido,partido.equipo_2,jugador.jugador,'ROJA')">{{jugador.jugador.persona.nombre_completo}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-header bgc-primary-d1" *ngIf="partido.equipo_2.detalles_ventas_pendientes.length>0">
                                    <p class="card-title text-white">Pendientes:</p>
                                    <select [compareWith]="compararObjectos" class="form-control" required name="usuario" [(ngModel)]="partido.equipo_2.pendiente_seleccionado">
                                        <option class="text-white" [ngClass]="{'bgc-danger':detalle_venta.producto.nombre.includes('ROJA'),'bgc-warning':detalle_venta.producto.nombre.includes('AMARILLA')}" [ngValue]="detalle_venta" *ngFor="let detalle_venta of partido.equipo_2.detalles_ventas_pendientes">{{detalle_venta.venta.fecha | date:'dd/MM/yyyy'}} {{detalle_venta.venta.saldo.toFixed(2)}} {{detalle_venta.producto.nombre}} {{detalle_venta.descripcion}}</option>
                                    </select>
                                    <button type="button" class="btn btn-success btn-sm" (click)="agregarPendiente(partido.equipo_2,partido.equipo_2.pendiente_seleccionado)">
                                        <i class="ace-icon fa fa-arrow-down bigger-110"></i>
                                    </button>
                                </div>
                                <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                                    <table class="table table-striped table-hover mb-0 text-danger">
                                        <thead class="text-dark-l2 text-95">
                                        <tr>
                                            <th>
                                            <i class="far fa-user text-blue mr-1px"></i>
                                            Pago
                                            </th>

                                            <th>
                                            <i class="fa fa-money-bill-alt text-success-d1 mr-1px"></i>
                                            Efectivo
                                            </th>
                                            <th>
                                            <i class="fa fa-qrcode text-black-d1 mr-1px"></i>
                                            QR
                                            </th>

                                            <th style="text-align: center;" data-field="tools">
                                            
                                            </th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr *ngFor="let detalle_pago of partido.equipo_2.detalle_pago">
                                            <td class="text-dark-m2">{{detalle_pago.producto.nombre}} {{detalle_pago.descripcion}}  {{detalle_pago.fecha}}</td>
                                            <td class="input-score">
                                                <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_2.id}}" [(ngModel)]="detalle_pago.importe">
                                            </td>
                                            <td class="input-score">
                                                <input (keyup)="sumarIngresos()" style="width: 80px;" type="number" min="0" step="0.001" class="form-control" name="{{i}}-{{partido.equipo_2.id}}" [(ngModel)]="detalle_pago.qr">
                                            </td>
                                            <td class="p-0" style="text-align: center;">
                                            <div class="action-buttons">
                                                <a class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger" href="javascript:void(0)" (click)="eliminarServicio(partido,partido.equipo_2,detalle_pago)">
                                                <i class="fa fa-trash-alt text-105"></i>
                                                </a>
                                            </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div><!-- /.card -->
                        </div>
                    </div>
                </div>

                <div class="card border-0 shadow-sm radius-0">
                    <!-- /.card-body -->
                </div><!-- /.card -->
            </div>
        </ng-container>
        <div class="row">
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <h5 class="widget-title text-success">Ingresos</h5>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Ingresos Efectivo</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_ingresos_efectivo}}</span>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Ingresos QR</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_ingresos_qr}}</span>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <h5 class="widget-title text-success">Egresos</h5>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Arbitro</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_arbitro" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Mesa</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_mesa" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Pago Otros</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6 input-score">
                        <input only-num class="form-control" (keyup)="sumarEgresos()" [(ngModel)]="cierre_caja.pago_otros" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <label>Total Egresos</label>
                    </div>
                    <div class="col-sm-6 col-md-6 col-6">
                        <span class="badge badge-danger text-white badge-lg radius-4 mb-1">Bs. {{cierre_caja.total_egresos}}</span>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-sm-12 col-md-12">
                        <span class="badge badge-danger text-white badge-lg radius-4 mb-1">Saldo Faltante</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <input (keyup)="sumarEgresos()" class="form-control" [(ngModel)]="cierre_caja.saldo_faltante" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <span class="badge badge-success text-white badge-lg radius-4 mb-1">Saldo Sobrante</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <input (keyup)="sumarIngresos()" class="form-control" [(ngModel)]="cierre_caja.saldo_sobrante" min="0" type="number" step="0.001">
                    </div>
                    <div class="col-sm-12 col-md-12">
                        <span class="text-primary">Saldo Final Caja</span>
                    </div>
                    <div class="col-sm-12 col-md-12">
                            <span class="badge mr-2 pos-rel p-2px text-white mt-2 radius-2 overflow-hidden text-180" [ngClass]="{'bgc-success':cierre_caja.saldo_caja>0,'bgc-danger':cierre_caja.saldo_caja<=0}">Bs. {{cierre_caja.saldo_caja}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #modal_lectura_planilla let-modal>
    <div class="modal-header card-header">
        <div class="col-7">
            <span class="text-blue text-125">Lectura de Planilla</span>
        </div>
        <div class="col-5">
            <button type="button" class="btn btn-primary" (click)="aplicarLecturaPlanilla()" title="Llenar el formulario con estos datos">
                <i class="fa fa-check red2 align-top bigger-125"></i>
            </button>&nbsp;
            <button type="button" class="btn btn-primary btn-danger" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 align-top bigger-125"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body" *ngIf="lectura_planilla">
        <p class="text-dark-m2 text-90 mb-2" *ngIf="lectura_planilla.cabecera">
            <i class="fa fa-file-alt mr-1"></i>{{lectura_planilla.cabecera}}
        </p>
        <div class="alert alert-warning py-1 px-2 mb-2" *ngIf="lectura_planilla.advertencias.length>0">
            <p class="mb-0 text-90" *ngFor="let advertencia of lectura_planilla.advertencias">
                <i class="fa fa-exclamation-triangle mr-1"></i>{{advertencia}}
            </p>
        </div>

        <div class="row mb-2">
            <div class="col-md-8 col-12">
                <label>Partido</label>
                <select [compareWith]="compararObjectos" class="form-control" name="partido_lectura" [(ngModel)]="lectura_planilla.partido" (change)="cambiarPartidoLectura()">
                    <option [ngValue]="partido" *ngFor="let partido of cierre_caja.partidos">{{partido.equipo_1.nombre}} vs {{partido.equipo_2.nombre}}</option>
                </select>
            </div>
            <div class="col-md-4 col-12">
                <label class="d-block">Foto</label>
                <button type="button" class="btn btn-sm btn-light-primary" (click)="lectura_planilla.ver_imagen=!lectura_planilla.ver_imagen">
                    <i class="fa fa-image mr-1"></i>{{lectura_planilla.ver_imagen?'Ocultar':'Ver'}}
                </button>
            </div>
            <div class="col-12 mt-1" *ngIf="lectura_planilla.ver_imagen">
                <img [src]="lectura_planilla.imagen" style="max-width:100%;" alt="planilla" />
            </div>
        </div>

        <div class="card border-0 shadow-sm radius-0 mb-2" *ngFor="let equipo_lectura of lectura_planilla.equipos; let e=index;">
            <div class="card-header bgc-primary-d1">
                <div class="row">
                    <div class="col-md-5 col-12">
                        <label class="text-white mb-0 text-90">Planilla: <b>{{equipo_lectura.planilla.nombre?equipo_lectura.planilla.nombre:'(ilegible)'}}</b></label>
                        <select [compareWith]="compararObjectos" class="form-control" name="equipo_lectura_{{e}}" [(ngModel)]="equipo_lectura.equipo" (change)="cambiarEquipoLectura(equipo_lectura)">
                            <option [ngValue]="lectura_planilla.partido.equipo_1">{{lectura_planilla.partido.equipo_1.nombre}}</option>
                            <option [ngValue]="lectura_planilla.partido.equipo_2">{{lectura_planilla.partido.equipo_2.nombre}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 col-6 input-score">
                        <label class="text-white mb-0 text-90">Marcador</label>
                        <input only-num type="number" min="0" step="1" class="form-control" name="marcador_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.marcador_final">
                    </div>
                    <div class="col-md-4 col-6 text-white text-90">
                        <label class="d-block mb-0"><input type="checkbox" name="balon_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_balon"> Sin balón</label>
                        <label class="d-block mb-0"><input type="checkbox" name="cintillo_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_cintillo"> Sin cintillo</label>
                        <label class="d-block mb-0"><input type="checkbox" name="ponchillos_lectura_{{e}}" [(ngModel)]="equipo_lectura.planilla.cobrar_ponchillos"> Ponchillos</label>
                    </div>
                </div>
            </div>
            <div class="card-body bgc-transparent p-0 border-1 brc-primary-m3 border-t-0">
                <table class="table table-striped table-hover mb-0 text-95">
                    <thead class="text-dark-l2 text-95">
                        <tr>
                            <th>Planilla</th>
                            <th>Goles</th>
                            <th title="Tarjeta amarilla">🟨</th>
                            <th title="Tarjeta roja">🟥</th>
                            <th>Jugador del sistema</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let jugador_lectura of equipo_lectura.jugadores; let j=index;">
                            <td class="text-dark-m2">
                                {{jugador_lectura.planilla.codigo}} {{jugador_lectura.planilla.nombre}}
                                <span *ngIf="jugador_lectura.planilla.numero" class="badge badge-sm badge-secondary ml-1">N° {{jugador_lectura.planilla.numero}}</span>
                                <span *ngIf="jugador_lectura.planilla.agregado_a_mano" class="badge badge-sm badge-warning ml-1" title="Escrito a mano fuera de la lista impresa">A MANO</span>
                            </td>
                            <td class="input-score">
                                <input only-num style="width: 70px;" type="number" min="0" step="1" class="form-control" name="goles_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.goles">
                            </td>
                            <td><input type="checkbox" name="amarilla_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.tarjeta_amarilla"></td>
                            <td><input type="checkbox" name="roja_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.planilla.tarjeta_roja"></td>
                            <td>
                                <select [compareWith]="compararObjectos" class="form-control" name="jugador_lectura_{{e}}_{{j}}" [(ngModel)]="jugador_lectura.jugador_equipo" [ngClass]="{'brc-danger-m1 border-2':!jugador_lectura.jugador_equipo}">
                                    <option [ngValue]="null">- No asignar -</option>
                                    <option [ngValue]="jugador_equipo" *ngFor="let jugador_equipo of equipo_lectura.equipo.jugadores | orderBy:'jugador.persona.nombre_completo'">{{jugador_equipo.jugador.persona.nombre_completo}}</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>